export const BulkOperationConstants = {
  UPLOAD_BULK_OPERATION_REQUEST: "UPLOAD_BULK_OPERATION_REQUEST",
  UPLOAD_BULK_OPERATION_SUCCESS: "UPLOAD_BULK_OPERATION_SUCCESS",
  UPLOAD_BULK_OPERATION_FAILURE: "UPLOAD_BULK_OPERATION_FAILURE",
};
